import { ClientConfigProductName } from '@frontend/vanilla/core';

export const TeaserLoader = {
    id: 'teaser',
    loaderFn: () => import(/* webpackChunkName: "ms-teaser-widget" */ './teaser.feature'),
    product: ClientConfigProductName.SPORTS,
};
